module.exports = require('lodash').isEqualWith